import React, { useEffect, useState } from "react";
import { MapTo } from "@adobe/aem-react-editable-components";
import {
	HeaderProps,
	HeaderMapTo,
	MenuItem,
	HeaderMenuModel,
} from "./Header.types";
import {
	RangoButton,
	RangoButtonGroup,
	RangoButtonGroupItem,
	RangoHeader,
	RangoIcon,
	RangoItemMenu,
	RangoListItemMenu,
	RangoListMenu,
	RangoParagraph,
} from "@rango/core";
import { useIsMobile } from "src/utils/js/useIsMobile";
import {
	HeaderStyled,
	LabelButtonStore,
	StoreMobileContainer,
	TitleContainer,
} from "./Header.styles";
import DrawerLogin from "./DrawerLogin";
import { useAleloContext } from "src/context/aleloContext";
import { handleLinkButtonClick } from "src/utils/js/handleLinkButtonClick";

export const HeaderEditConfig: any = {
	emptyLabel: "Alelo - Header Component",
	isEmpty: function (props: HeaderProps) {
		return !props || props.header == null;
	},
};

export default function Header({ header, fixed }: HeaderProps) {
	const { isMobile } = useIsMobile();
	const [responsive, setResponsive] = useState(isMobile);

	const { setCurrentModal } = useAleloContext();

	const listMenus = header?.listMenus ?? [];
	const storeLink = header?.storeLink;

	useEffect(() => {
		setResponsive(isMobile);
	}, [isMobile]);

	function MenuItem({ title, listItems, imageUrl, target }: MenuItem) {
		return (
			<>
				{!responsive && (
					<TitleContainer>
						{imageUrl && <img src={imageUrl} alt="" loading="lazy" />}

						<RangoParagraph>{title}</RangoParagraph>
					</TitleContainer>
				)}

				{listItems?.map((item, index) => {
					const targetProps = {
						title: item.submenuTitle || "Menu Link",
						element_parent: "Header",
						element_type: "Link",
						destination: item.submenuLink || "",
					};
					return (
						<RangoItemMenu
							{...targetProps}
							key={index}
							index={index}
							label={item.submenuTitle}
							href={item.submenuLink}
							target="_self"
							as="a"
						/>
					);
				})}
			</>
		);
	}

	function MultiMenuItem({ title, listItems, imageUrl, target }: MenuItem) {
		return (
			<div className="rango-col-3">
				<MenuItem
					title={title}
					listItems={listItems}
					imageUrl={imageUrl}
					target={target}
				/>
			</div>
		);
	}

	function MenuGrid(props: HeaderMenuModel) {
		if (!props.multiColumn || responsive) {
			return props.listCategorySubmenu?.map((category, index) => (
				<MenuItem
					target={props.target}
					key={index}
					title={category.titleCategory}
					listItems={category.listSubMenus}
					imageUrl={category.imageUrl}
				/>
			));
		}

		return (
			<div className="rango-container">
				<div className="rango-row">
					{props.listCategorySubmenu?.map((category, index) => (
						<MultiMenuItem
							target={props.target}
							key={index}
							title={category.titleCategory}
							listItems={category.listSubMenus}
							imageUrl={category.imageUrl}
						/>
					))}
				</div>
			</div>
		);
	}
	return (
		<HeaderStyled>
			{header && (
				<>
					<RangoHeader
						onResponsive={setResponsive}
						responsive={responsive}
						showAction
						showNav
						fixed={fixed}
						brandProps={{
							as: "a",
							href: header.homeLink + ".html" || "#alelo",						
							style: {cursor: 'pointer'},
							...{
									destination: header.homeLink || "#alelo",
									title: "home",
									element_parent: "header",
									element_type: "link"
								}						
					}}
					>
						<div
							slot="nav"
							style={{
								width: "283px",
							}}
						>
							<RangoListMenu
								type={responsive ? "Vertical" : "Horizontal"}
								as="nav"
							>
								{listMenus?.map((menu, index) => {
									const targetProps = {
										title: menu.menuTitle || "menuLink",
										element_parent: menu.target?.elementParent,
										element_type: menu.target?.elementType,
										destination: menu.menuLink || menu.menuTitle || "",
									};

									return menu.menuLink ? (
										<RangoItemMenu
											{...targetProps}
											style={{ padding: responsive ? "0 24px" : "" }}
											key={index}
											label={menu.menuTitle}
											index={index}
											href={menu.menuLink}
											target="_self"
											as="a"
										/>
									) : (
										<RangoListItemMenu
											{...targetProps}
											key={index}
											type={responsive ? "Vertical" : "Horizontal"}
											label={menu.menuTitle}
											// tag="Minha Tag"
											index={index}
											showSubMenu={!menu.menuLink}
											onClick={() =>
												menu.menuLink
													? (window.location.href = menu.menuLink)
													: null
											}
											// as="a"
										>
											<MenuGrid {...menu} />
										</RangoListItemMenu>
									);
								})}
							</RangoListMenu>
						</div>

						<div slot="buttons">
							<RangoButtonGroup
								size="lg"
								orientation={responsive ? "vertical" : "horizontal"}
							>
								{storeLink && !responsive ? (
									<RangoButtonGroupItem			
										onMouseDown={(event) => event.preventDefault()}
										onMouseUp={(event) => handleLinkButtonClick(storeLink, event)}						
										slot="primary"
										variant="primary"
										title="Quero Alelo"		
																		
										{...{
											element_parent: "header",
											element_type: "link",
											destination: storeLink,
										}}
									>
										<LabelButtonStore>
											<RangoIcon
												style={{ color: "white" }}
												icon="BagSelected"
											/>
											{header.storeLabel || "Quero Alelo"}
										</LabelButtonStore>
									</RangoButtonGroupItem>
								) : (
									<></>
								)}

								<RangoButtonGroupItem
									onClick={() =>
										setCurrentModal({ modal: "loginDrawer", step: "" })
									}
									slot="primary"
									variant="primary"
									title="Sou Cliente"
									{...{
										element_parent: "header",
										element_type: "button",
										destination: "loginDrawer",
									}}
								>
									{header.loginLabel || "Sou Cliente"}
								</RangoButtonGroupItem>
							</RangoButtonGroup>
						</div>
					</RangoHeader>

					{storeLink && responsive ? (
						<StoreMobileContainer fixed={fixed}>
							<RangoButton
								size="lg"
								className="store-button-mobile"
								onClick={() => (window.location.href = storeLink)}
								title={header.storeLabel || "Quero Alelo"}
								{...{
									element_parent: "header",
									element_type: "link",
									destination: storeLink,
								}}
							>
								<RangoIcon
									style={{ color: "var(--action-bg-primary-color)" }}
									icon="BagSelected"
								/>
							</RangoButton>
						</StoreMobileContainer>
					) : (
						<></>
					)}
					<DrawerLogin {...header} />
				</>
			)}
		</HeaderStyled>
	);
}

MapTo<HeaderMapTo>("alelo/components/content/v1/header")(
	Header,
	HeaderEditConfig
);
